import { nsUser } from '@/app/i18n/namespaces';
import USER_ADVANCED_AUTH from '../enums/UserAdvancedAuth';
import USER_STATUS from '../enums/UserStatus';
import { FIELD_TYPES } from '@/common-utils/components/renders/detailsGrid/FieldTypes';
import { FILTER_TYPES } from '@/common-utils/components/renders/dataTable/filter/FilterTypes';

export default {
    UUID: {
        key: 'uuid',
        enableSorting: false
    },
    DETAILS: {
        key: 'details',
        enableSorting: false
    },
    ORGANIZATION_UUID: {
        key: 'organization'
    },
    EMAIL: {
        key: 'email',
        entity: 'keys.email',
        type: 'email',
        namespace: nsUser,
        placeholder: 'filter.placeholder.email',
        //validate: validateEmail,
        enableSorting: true,
        filter: FILTER_TYPES.INPUT
    },
    STATUS: {
        key: 'status',
        type: FIELD_TYPES.BADGE,
        entity: 'keys.status',
        namespace: nsUser,
        prefix: 'user_status_',
        enum: USER_STATUS,
        enableSorting: true,
        filter: FILTER_TYPES.SELECT
    },
    PASSWORD: {
        key: 'password',
        entity: 'user_password',
        type: 'password',
        //validate: password => password ? undefined : 'EMPTY_PASSWORD',
        isRequired: true
    },
    PASSWORD_CONFIRMATION: {
        key: 'passwordConfirmation',
        entity: 'user_password_confirmation',
        type: 'password',
        isRequired: true
    },
    TOTP: {
        key: 'totp',
        type: FIELD_TYPES.TEXT,
        entity: 'user_totp'
        //validate: (totp) => (totp && /^\d{6}$/.test(totp)) ? undefined : 'REQUIRED'
    },
    CREATED_AT: {
        key: 'createdAt',
        type: FIELD_TYPES.DATE,
        namespace: nsUser,
        entity: 'keys.created_at',
        enableSorting: true,
        filter: FILTER_TYPES.DATE
    },
    UPDATED_AT: {
        key: 'updatedAt',
        type: FIELD_TYPES.DATE,
        namespace: nsUser,
        entity: 'keys.updated_at',
        enableSorting: true,
        filter: FILTER_TYPES.DATE
    },
    LAST_LOGIN_AT: {
        key: 'lastLoginAt',
        type: FIELD_TYPES.DATE,
        namespace: nsUser,
        entity: 'keys.last_login_at',
        enableSorting: true,
        filter: FILTER_TYPES.DATE
    },
    PROFILE: {
        key: 'profileName',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.profile',
        namespace: nsUser,
        prefix: 'profile.',
        enableSorting: false
    },
    PERMISSIONS: {
        key: 'permissionList',
        type: FIELD_TYPES.TEXT,
        entity: 'user_permissions',
        prefix: 'permissions_'
    },

    NEW_ACCOUNT: {
        key: 'newAccount'
    },
    ADVANCED_AUTH: {
        key: 'hasMfa',
        type: FIELD_TYPES.BOOLEAN,
        entity: 'keys.has_mfa',
        tooltip: 'tooltip.has_mfa',
        namespace: nsUser,
        moreInfoEntity: 'user_has_mfa_extended',
        prefix: 'has_mfa.',
        enableSorting: true,
        enum: USER_ADVANCED_AUTH,
        filter: FILTER_TYPES.SELECT
    },
    ROLES: {
        key: 'roles'
    },
    PROFILE_NAME: {
        key: 'name'
    },
    PROFILE_PERMISSIONS: {
        key: 'permissions'
    },
    IS_PRELUDD: {
        key: 'isPreludd'
    },
    IS_DIRECT_PRELUDD_CLIENT: {
        key: 'isDirectPreluddClient'
    }
};